import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the myAccount state domain
 */

const selectMyAccountDomain = (state) => state.get("myAccount", initialState)

export const makeSelectLanguage = () =>
  createSelector(selectMyAccountDomain, (state) => state.get("languages"))

export const makeSelectIsLoadingLanguage = () =>
  createSelector(selectMyAccountDomain, (state) =>
    state.get("isLoadingLanguage")
  )
/**
 * Other specific selectors
 */
export const makeSelectUser = () =>
  createSelector(selectMyAccountDomain, (state) => state.get("user"))

export const makeSelectIsLoadingUser = () =>
  createSelector(selectMyAccountDomain, (state) => state.get("isLoadingUser"))
/**
 * Default selector used by MyAccount
 */

const makeSelectMyAccount = () =>
  createSelector(selectMyAccountDomain, (substate) => substate.toJS())

export default makeSelectMyAccount
export { selectMyAccountDomain }
